import urlConditional from './apiInfo'

const baseUrl = urlConditional();
const location = "https://www.g2g-api.com"

const authManager = {
  async loginUser(user) {
    const resp = await fetch(`${location}/login/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(user),
    });
    return await resp.json();
  },
  async registerUser(user) {
    return await fetch(`${baseUrl}/register/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(user),
    }).then(resp=>resp.json());
  },
};

export default authManager;